import { render } from "./Table.vue?vue&type=template&id=3e1e24b8&scoped=true"
import script from "./Table.vue?vue&type=script&lang=ts"
export * from "./Table.vue?vue&type=script&lang=ts"

import "./Table.vue?vue&type=style&index=0&id=3e1e24b8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3e1e24b8"

export default script